export const sample = {
  NAME: 22, //姓名
  CELLPHONE: 23, //手机号
  EMAIL: 24, //邮箱
  CURRENT_LOCATION: 25, //当前所在地
  REAL_NAME: 26, //真实姓名
  GENDER: 27, //性别
  PERMANENT_ADDRESS: 28, //常住地
  DATE_OF_BIRTH: 29, //出生日期
  CERTIFICATE_TYPE: 30, // 证件类型
  ID_NUMBER: 31 //证件号
}

export const questionLib = {
  NAME: 22, //姓名
  CELLPHONE: 23, //手机号
  EMAIL: 24, //邮箱
  GENDER: 27, //性别
  PERMANENT_ADDRESS: 28, //常住地
  DATE_OF_BIRTH: 29, //出生日期
  ID_NUMBER: 31, //证件号
  AGE_RANGE: 32, // 年龄
  DOMICILE: 33, // 户籍地
  EDUCATIONAL_ATTAINMENT: 34, // 学历
  SPECIALITY: 35, // 专业
  SCHOOL: 36, // 院校
  INDUSTRY: 37, // 行业
  JOB: 38, // 职业
  MARITAL_STATUS: 39, // 婚姻状况
  MONTHLY_INCOME_RANGE: 40 // 个人月收入
}

const FORMAT_QUESTION = {
  CITY_ADDRESS: 19, //城市/地址题
  MAP: 100 //地理位置题
}
const WJB_8_121 = {
  CUSTOM_SINGLE_SCALE: 15, // 自定义单行量表题
  CUSTOM_MULTIPLE_SCALE: 16 // 自定义多行量表题
}

const WJB_2020_11 = {
  UPLOAD_FILE: 18
}

const WJB_2021_04 = {
  MATRIX_AUTO: 102, // 自增表格
  MATRIX_SCROLL: 103, // 矩阵滚动条
  MATRIX_GRAVITY: 104, // 比重题
  MULTIPLE_BLANKS: 105, // 多项填空题
  MATRIX_COMPOSE: 110, //表格组合
  PHONE_VALIDATE: 109 //手机验证题
}

const WJB_2021_05 = {
  IMAGE_CHOICE: 113, //图片选择
  CLASSIFICATION: 111, // 分类题
  DOWNLOADABLE: 112, // 可下载附件
  CASCADE_REGION: 114, // 行政区划题
  IMAGE_MULTIPLE_CHOICE: 117 //图片多选
}

const MATRIX_CELL = {
  MATRIX_CELL: 101,
  MATRIX_SELECT: 106,
  MATRIX_FILL: 107
}

const WJB_2021_07 = {
  QUESTION_GROUP: 115 // 问题组
}

const newTypes = {
  ...WJB_2021_04,
  ...WJB_2021_05,
  ...WJB_2021_07
}

export const questionTypeEnum = {
  SINGLE_CHOICE: 1, // 单选
  MULTIPLE_CHOICE: 2, // 多选
  MATRIX_SINGLE_CHOICE: 5, // 矩阵选择题
  MATRIX_MULTIPLE_CHOICE: 6, // 矩阵选择题
  LINKAGE: 3, // 联动题
  SINGLE_TEXT_FILL: 7, // 文本填充题
  MULTIPLE_TEXT_FILL: 8, // 文本填充题
  // NUMERICAL_FILL: 1002, // 数值填充题
  SINGLE_SELECT: 12, // 下拉题
  MULTIPLE_SELECT: 13, // 下拉题
  HANDWRITING: 14, // 手写签名
  DATE: 17, // 日期题
  // MAILBOX: 103, // 邮箱题
  // URL_LINK: 104, // 网址链接题
  // PHONE: 105, // 电话题
  // TIME: 106, // 时间题
  // ADDRESS: 107, // 地址题
  // PROPORTION: 108, // 比重题
  SORT: 11, //排序题
  // TEXT_DESCRIPTION: 1009, //文本描述
  SCALE: 21, // 量表题
  MATRIX_SCALE: 9, // 矩阵量表题
  PAGE_BREAK: 108, // 分页符
  BLANKS: 4,
  ONLY_TEXT: 20, // 纯文本描述
  NPS_SCALE: 10,
  // 样本类型
  ...sample,
  ...WJB_8_121,
  ...WJB_2020_11,
  ...questionLib,
  ...FORMAT_QUESTION,
  ...MATRIX_CELL,
  ...newTypes
}
